/**
 * @file YProvider hook
 */

import { useEffect, useState } from 'react'
import type * as Y from 'yjs'

import YPartyKitProvider from './provider'

interface UseYPartyKitProviderOptions {
  host?: string | undefined
  room: string
  party?: string
  doc?: Y.Doc
  options?: ConstructorParameters<typeof YPartyKitProvider>[3]
  onDestroy?: (errorMessage?: string) => void
}

export default function useYProvider(yProviderOptions: UseYPartyKitProviderOptions) {
  const { host, room, party, doc, options, onDestroy } = yProviderOptions
  const [provider] = useState<YPartyKitProvider>(
    () =>
      new YPartyKitProvider(
        host || (typeof window !== 'undefined' ? window.location.host : 'dummy-domain.com'),
        room,
        doc,
        {
          connect: false,
          party,
          ...options,
        },
        onDestroy,
      ),
  )

  useEffect(() => {
    provider.connect(onDestroy)
    return () => provider.disconnect()
  }, [provider])
  return provider
}
